module.exports = __webpack_public_path__ + "img/Hlogo.3164d4c9.png";